<template>

    <section class="py-10 lg:py-20 bg-lifeboost-red-lighter">
        <div class="grid max-w-screen-xl px-4 mx-auto lg:gap-y-8">


            <div class="grid items-center grid-cols-1 md:grid-cols-2 lg:gap-x-0 md:gap-x-12 md:gap-y-0 gap-y-8">
                <div>
                    <h3 class="mb-4 font-bold h2">
                        Frosted Sugar Cookie
                    </h3>

                    <p class="textp">
                        “Did I ever tell you about the first date your mother and I ever went on?”
                        <br><br>
                        “Yes, dad,” the twins replied with a smirky grin.
                        <br><br>
                        “Ah, it feels like it was just yesterday.”
                        <br><br>
                        “I’m pretty sure you just told us this story last week, dad.”
                        <br><br>
                        “So, there she was, her nose stuck in a book, sitting underneath the big oak tree in the quad.
                        <br><br>
                        I couldn’t believe anyone could be so captivated. This beautiful woman was so enthralled by what
                        she was reading that life seemed not to exist outside of the paper world held in her hand.
                        <br><br>
                        I walked by that tree every afternoon coming home from class, and every single day...there she
                        sat.
                        <br><br>
                        Finally, I decided I had to meet her.
                    </p>
                </div>

                <div>

                    <nuxt-img width="400" height="440" format="webp" src="/assets/images/sugar-cookie.jpg"
                        alt="section image" class="object-cover w-full lg:pl-10" loading="lazy"
                        sizes="xs:330px sm:440px md:745vw lg:388px xl:400" />

                </div>

            </div>

            <div class="grid items-center lg:grid-cols-12 gap-x-6 lg:gap-y-0 gap-y-6">

              <div class="flex flex-col col-span-12 lg:grid md:flex-row lg:col-span-6 lg:pr-10 gap-y-8 sm-max:order-2">
                <nuxt-img width="499" height="450" format="webp" src="/assets/images/frosted-1.jpg" alt="section image"
                    class="object-cover w-full max-h-" loading="lazy" sizes="xs:330px sm:440px md:745vw lg:388px xl:494" />

                    <nuxt-img width="499" height="450" format="webp" src="/assets/images/frosted-2.jpg" alt="section image"
                    class="object-cover w-full" loading="lazy" sizes="xs:330px sm:440px md:745vw lg:388px xl:494" />
              </div>



                <div class="col-span-12 mt-4 lg:col-span-6 md:mt-0">

                    <div>


                        <p class="textp">
                            Not being much of a reader, I haphazardly checked out a book from the library and sat down
                            with said book on the other side of the tree not even a full 2 feet from her.
                            <br><br>
                            Then, after recklessly flipping through a few pages, I spoke. I asked what she was reading,
                            and she laughed at me. Your mother’s first response to your old man was that I was a joke.
                            <br><br>
                            She was right. She saw right through my attempt and didn’t reply with the answer to my
                            direct question, but to the question I was building up to ask.”
                            <br><br>
                            “Sure. I could go for a coffee break right now anyways.”
                            <br><br>
                            “I was stunned. I mean, to be honest, I actually didn’t even drink coffee during my college
                            years. It was your mother that got me fixated on the bean.”
                            <br><br>
                            “Really, dad? The bean?”
                            <br><br>
                            “Anyways, she stood straight up and of course, I stumblingly followed.
                            <br><br>
                            We went to the local college coffeehouse, the only one on campus. She ordered a small medium
                            roast, black. And, I ordered the same, along with a frosted sugar cookie.
                            <br><br>
                            My parents always brewed some generic store bought coffee. The smell wasn’t great anyways,
                            but my mom generally burned the coffee too, so my history with the bean wasn’t all that
                            grand.
                            <br><br>
                            But this coffee...this coffee was purely perfect, just like your mother.
                            <br><br>
                            We sat and talked for hours.
                            <br><br>
                            And, later I had to finally admit to her that I was just as enamored with that coffee and
                            frosted sugar cookie combo as I was with her. ...well, not on the same level, but it was so
                            amazing that we go to the same coffeehouse every year on the anniversary of that date to
                            enjoy the same treat.
                            <br><br>
                            The aroma of the coffee was like nothing I’d experienced, bold and robust. The flavor was
                            rich, with such incredible depth.

                            

                        </p>
                    </div>

                </div>

                <p class="col-span-12 mt-8 textp">
            Ah, and paired with that sugar cookie! The frosting was sweet and velvety, the cookie was delicately decadent, so rich, sweet, and buttery.”
            <br><br>
“Well, well, well, I see you’re telling our children about how much you love frosted sugar cookies and coffee...am I even in this story anymore?”
<br><br>
“Oh, hi dear. Of course you’re in the story. You’re the reason for the story!”
<br><br>
The twins and their mother laughed in unison...their father still clearly thinking of the delectable confectionary combination. 
          </p>

            </div>

   

        </div>

    </section>


</template>

<script setup>

defineBuilderComponent({
    friendlyName: 'TextWithImages',
    ignored: true
})

</script>